import { Phone } from "lucide-react";
import { PHONE_TEL } from "@/data/site";

export const CallFab = () => (
  <a
    href={PHONE_TEL}
    data-testid="floating-call-btn"
    aria-label="Call HF Landscape Solutions"
    className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-[var(--leaf)] px-5 py-4 font-bold text-white shadow-[0_20px_40px_-12px_rgba(15,74,19,0.6)] transition-transform duration-300 hover:-translate-y-1 sm:hidden"
  >
    <span className="relative flex h-2.5 w-2.5"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/70" /><span className="relative h-2.5 w-2.5 rounded-full bg-white" /></span>
    <Phone className="h-4 w-4" /> Call now
  </a>
);
